import { FetchActions, createFetchActions } from '@syncfab/machine'
import { BlockchainOrder } from './Blockchain'
export const GET_BLOCKCHAIN_ORDER: FetchActions<{ id: string }, BlockchainOrder> = createFetchActions('GET_BLOCKCHAIN_ORDER')
